import u from "styled-components";
import x from "../../text/text.js";
const d = u.button(
  ({ theme: c, $width: e, $widthX: i, $alignSelf: o, $justifyContent: t, $renderAs: a, $size: n, $shape: $ }) => {
    const { button: b, colors: r, layout: p } = c, { backgroundColorName: s, borderColorName: l } = b.variants[a], { height: v, paddingHorizontal: g, borderWidth: h } = b.sizes[n];
    return `
      position: relative;
      display: flex;
      justify-content: ${t};
      align-items: center;
      ${o ? `align-self: ${o};` : ""}
      
      width: ${e ? `${e}px` : "auto"};
      ${i ? `width: ${i * p.gutter}px;` : ""}
      height: ${v}px;
      padding: 0 ${g}px;
      border-width: ${h}px;
      border-style: solid;
      border-radius: ${$ === "curved" ? v / 2 : 0}px;
      outline: none;

      background-color: ${r[s.inactive]};
      border-color: ${r[l.inactive]};
      
      transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
      cursor: pointer;

      &:hover {
        background-color: ${r[s.active]};
        border-color: ${r[l.active]};
      }

      &:active  {
        background: ${r[s.inactive]};
        border-color: ${r[l.inactive]};
      }

      &[data-busy="true"] {
        cursor: wait;
        background-color: ${r[s.active]};
        border-color: ${r[l.active]};
      }

      &:disabled {
        background-color: ${r[s.disabled]};
        border-color: ${r[l.disabled]};
        cursor: not-allowed;
      }
  `;
  }
), k = u(x)(({ theme: c, $buttonRenderAs: e }) => {
  const { button: i, colors: o } = c, { colorName: t } = i.variants[e];
  return `
      color: ${o[t.inactive]};
      transition: color 0.2s ease-in-out;

      ${d}:hover & {
        color: ${o[t.active]};
      }
      
      ${d}:active & {
        color: ${o[t.inactive]};
      }

      ${d}:disabled & {
        color: ${o[t.disabled]};
        opacity: 0.5;
      }
    `;
}), f = u.div(({ theme: c, $buttonRenderAs: e, $size: i, $iconPosition: o }) => {
  const { button: t, colors: a } = c, { colorName: n } = t.variants[e], { iconSize: $, iconPadding: b } = t.sizes[i];
  return `
      ${o === "left" ? "padding-right" : "padding-left"}: ${b}px;
      order: ${o === "left" ? -1 : 1};
      
      & svg {
        display: block;
        width: ${$}px;
        height: ${$}px;
        color: ${a[n.inactive]};
        transition: color 0.2s ease-in-out;

        ${d}:hover & {
          color: ${a[n.active]};
        }

        ${d}:active & {
          color: ${a[n.inactive]};
        }

        ${d}:disabled & {
          color: ${a[n.disabled]};
          opacity: 0.5;
        }
      }
    `;
}), z = u.img(({ theme: c, $size: e }) => {
  const { button: i } = c, { loaderSize: o } = i.sizes[e];
  return `
    width: ${o}px;
    height: ${o}px;
  `;
});
export {
  d as Button,
  f as Icon,
  k as Label,
  z as Loader
};
//# sourceMappingURL=button-styled.js.map
